module.exports = __webpack_public_path__ + "img/hovered-layer7.a597fd37.png";